export default __webpack_public_path__ + "static/media/Sorcerer's Leggings of Regal Might.08dee004.jpg";